
import { commsManager } from "appworks/server/comms-manager";
import { Services } from "appworks/services/services";
import { Contract } from "appworks/utils/contracts/contract";
import { SpinRequestPayload } from "slotworks/model/gameplay/requests/spin-request-payload";

export function LoadSpinCommand(): Contract<void> {
    const payload = new SpinRequestPayload();
    payload.creditPerLine = Services.bet.getCreditPerLine();
    payload.creditSize = Services.bet.getCreditSize();

    return commsManager.request(payload);
}
